/* MV Sortiment assets/mv-sortiment.ratgeber.js - Paket N-1 - 2026-10-07
 *
 * Wissenszentrale (sections/mv-wissen-hub.liquid, Spezifikation _docs/n1-ratgeber.md). Wurzel [data-mv-ratgeber];
 * ohne Wurzel auf der Seite tut das Skript nichts (Waechter).
 *  1. Sofortsuche [data-mv-ratgeber-suche] ueber alle Inhaltstypen aus dem JSON-Datenblock
 *     script[type="application/json"][data-mv-ratgeber-index] (Text des Snippets mv-ratgeber-index, von
 *     _build/ratgeber-bauen.mjs erzeugt). Ab zwei Zeichen: alle Woerter muessen vorkommen (Titel, Stichwoerter,
 *     Kurztext, Meta); Gross/klein, Akzente, Umlaute und Umschrift (ae/oe/ue, ss) zaehlen nicht. Treffer gruppiert nach
 *     Typ in der Reihenfolge der T-Saetze, je Gruppe hoechstens PRO_GRUPPE, zuerst Treffer im Titel. Ohne Treffer der
 *     Hinweis aus der Vorlage; als letzte Option immer der Link in die Shop-Suche (/search?q=...).
 *     Tastatur: Pfeil runter/hoch waehlt (aria-activedescendant), Enter oeffnet die gewaehlte Option (ohne Auswahl
 *     schickt das Formular an die Shop-Suche), Escape schliesst bzw. leert. Ohne JavaScript ist das Feld ein normales
 *     Suchformular der Shop-Suche.
 *  2. Einstieg nach Situation [data-mv-ratgeber-situationen]: die vier Kacheln werden Reiter (role tab, Pfeiltasten,
 *     Pos1/Ende), je Reiter ein Set (role tabpanel). Ohne JavaScript stehen alle Sets untereinander, die Kacheln
 *     springen per Anker hin.
 *  3. Themen [data-mv-ratgeber-thema]: ?thema=<kategorie>, #thema-<kategorie> und der alte Anker #wissen-<kategorie>
 *     markieren die Kachel und scrollen hin; ?situation=<kennung> und #situation-<kennung> waehlen die Situation. Auch
 *     bei hashchange (Themen-Chips, Brotkrumen der Beitraege). Seit Paket W-2 (2026-10-10) zeigt jede Kachel alle
 *     Beitraege; das Skript klappt nichts mehr auf ("Passend dazu" bleibt zu), ohne Skript springt der Anker allein.
 * Keine sichtbaren Texte in diesem Skript: Gruppentitel kommen aus den Daten, alle uebrigen Texte und Icons aus den
 * Vorlagen und data-Attributen der Sektion (Liquid). Kein Fetch, keine Analytics, nichts in die Adresse geschrieben.
 * Delegation auf document; shopify:section:load startet neu. Laedt allein und in beliebiger Reihenfolge als Teil von
 * assets/mv-sortiment.js (_build/konkat.sh). Unter Node (Tests) liefert die Datei nur die reinen Funktionen.
 * Kommentare und Datei ASCII.
 */
;(function () {
  'use strict';

  var VERSION = '2026-10-10.1';
  var MIN_ZEICHEN = 2;
  var PRO_GRUPPE = 5;
  var VERZOEGERUNG = 80;

  // ===========================================================================================
  // Teil 1: reine Logik
  // ===========================================================================================

  // Vergleichsform: wortgleich mit normalisiere() in _build/ratgeber-bauen.mjs (der Test vergleicht)
  function normalisiere(text) {
    var s = String(text == null ? '' : text).toLowerCase();
    if (typeof s.normalize === 'function') s = s.normalize('NFD');
    return s
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/\u00df/g, 'ss')
      .replace(/ae/g, 'a')
      .replace(/oe/g, 'o')
      .replace(/ue/g, 'u')
      .replace(/[^a-z0-9]+/g, ' ')
      .replace(/^ +| +$/g, '');
  }

  // Index-Text (Datensaetze an zwei Tilden, Felder am senkrechten Strich) -> Typen und Eintraege mit Suchfeldern
  function zerlegeIndex(text) {
    var typen = [];
    var eintraege = [];
    var saetze = String(text == null ? '' : text).split('~~');
    for (var i = 0; i < saetze.length; i++) {
      var f = saetze[i].split('|');
      for (var j = 0; j < f.length; j++) f[j] = f[j].replace(/^\s+|\s+$/g, '');
      if (f[0] === 'X') break;
      if (f[0] === 'T' && f.length >= 10) {
        typen.push({ typ: f[1], titel: f[2], kicker: f[3], url: f[7], icon: f[8] });
      } else if (f[0] === 'E' && f.length >= 10) {
        eintraege.push({
          id: f[1], typ: f[2], titel: f[3], kurz: f[4], url: f[5], thema: f[6], meta: f[7], icon: f[8], woerter: f[9],
          nt: ' ' + normalisiere(f[3]), nw: ' ' + normalisiere(f[9]), nk: ' ' + normalisiere(f[4]), nm: ' ' + normalisiere(f[7]),
          reihe: eintraege.length
        });
      }
    }
    return { typen: typen, eintraege: eintraege };
  }

  // Punkte eines Eintrags fuer die Suchwoerter (0 = kein Treffer: jedes Wort muss vorkommen)
  function punkteFuer(e, woerter, ganz) {
    var summe = 0;
    for (var i = 0; i < woerter.length; i++) {
      var w = woerter[i];
      var p = 0;
      if (e.nt.indexOf(' ' + w) >= 0) p = 6;
      else if (e.nt.indexOf(w) >= 0) p = 4;
      else if (e.nw.indexOf(' ' + w) >= 0) p = 3;
      else if (e.nw.indexOf(w) >= 0 || e.nk.indexOf(' ' + w) >= 0) p = 2;
      else if (e.nk.indexOf(w) >= 0 || e.nm.indexOf(w) >= 0) p = 1;
      if (!p) return 0;
      summe += p;
    }
    if (e.nt === ' ' + ganz) summe += 10;
    else if (e.nt.indexOf(' ' + ganz) === 0) summe += 4;
    return summe;
  }

  // Suche: { anfrage, gesamt, gruppen: [{ typ, titel, anzahl, eintraege }] } oder null unter MIN_ZEICHEN
  function suche(index, anfrage, optionen) {
    var pro = (optionen && optionen.proGruppe) || PRO_GRUPPE;
    var ganz = normalisiere(anfrage);
    if (ganz.replace(/ /g, '').length < MIN_ZEICHEN) return null;
    var woerter = ganz.split(' ');
    var je = {};
    var gesamt = 0;
    for (var i = 0; i < index.eintraege.length; i++) {
      var e = index.eintraege[i];
      var p = punkteFuer(e, woerter, ganz);
      if (!p) continue;
      gesamt++;
      (je[e.typ] = je[e.typ] || []).push({ e: e, p: p });
    }
    var gruppen = [];
    for (var t = 0; t < index.typen.length; t++) {
      var typ = index.typen[t];
      var liste = je[typ.typ];
      if (!liste || !liste.length) continue;
      liste.sort(function (a, b) { return b.p - a.p || a.e.reihe - b.e.reihe; });
      var top = [];
      for (var k = 0; k < liste.length && k < pro; k++) top.push(liste[k].e);
      gruppen.push({ typ: typ.typ, titel: typ.titel, icon: typ.icon, anzahl: liste.length, eintraege: top });
    }
    return { anfrage: ganz, gesamt: gesamt, gruppen: gruppen };
  }

  // Text in Abschnitte mit Markierung der Suchwoerter (Vergleich ueber die Normalform je Zeichen)
  function abschnitte(text, anfrage) {
    var s = String(text == null ? '' : text);
    var woerter = normalisiere(anfrage).split(' ').filter(function (w) { return w.length >= MIN_ZEICHEN; });
    if (!woerter.length || !s) return [{ text: s, mark: false }];
    // Normalform je Zeichen mit Rueckverweis auf die Stelle im Original
    var norm = '';
    var herkunft = [];
    for (var i = 0; i < s.length; i++) {
      var n = normalisiere(s.charAt(i));
      if (!n && /\s/.test(s.charAt(i))) n = ' ';
      for (var j = 0; j < n.length; j++) { norm += n.charAt(j); herkunft.push(i); }
    }
    // Umschrift auch ueber Zeichengrenzen (ae, oe, ue) wie normalisiere() fuer das ganze Wort
    norm = norm.replace(/ae/g, 'a\u0000').replace(/oe/g, 'o\u0000').replace(/ue/g, 'u\u0000');
    var marke = [];
    for (var w = 0; w < woerter.length; w++) {
      var ab = 0;
      var muster = woerter[w];
      var ohne = norm.replace(/\u0000/g, '');
      var karte = [];
      for (var c = 0; c < norm.length; c++) if (norm.charAt(c) !== '\u0000') karte.push(c);
      while (ab <= ohne.length - muster.length) {
        var pos = ohne.indexOf(muster, ab);
        if (pos < 0) break;
        var von = herkunft[karte[pos]];
        var bis = herkunft[karte[pos + muster.length - 1]];
        for (var x = von; x <= bis; x++) marke[x] = true;
        ab = pos + muster.length;
      }
    }
    var aus = [];
    var akt = null;
    for (var y = 0; y < s.length; y++) {
      var m = !!marke[y];
      if (!akt || akt.mark !== m) { akt = { text: '', mark: m }; aus.push(akt); }
      akt.text += s.charAt(y);
    }
    return aus;
  }

  // Ziel aus Adresse: ?thema= und ?situation= (zuerst), sonst #thema-, #wissen- (alter Anker) und #situation-
  function zielAusAdresse(suchteil, anker) {
    var q = String(suchteil || '').replace(/^\?/, '').split('&');
    for (var i = 0; i < q.length; i++) {
      var p = q[i].split('=');
      var name = p[0];
      var wert = '';
      try { wert = decodeURIComponent((p[1] || '').replace(/\+/g, ' ')); } catch (_) { wert = ''; }
      wert = wert.toLowerCase().replace(/[^a-z0-9-]/g, '');
      if (!wert) continue;
      if (name === 'thema') return { art: 'thema', kennung: wert };
      if (name === 'situation') return { art: 'situation', kennung: wert };
    }
    var h = String(anker || '').replace(/^#/, '');
    var m = /^(thema|wissen|situation)-([a-z0-9-]+)$/.exec(h);
    if (!m || m[2] === 'themen') return null;
    return { art: m[1] === 'situation' ? 'situation' : 'thema', kennung: m[2] };
  }

  // Naechste Option fuer Pfeiltasten (zyklisch); aktuell -1 = keine
  function naechsterIndex(aktuell, anzahl, richtung) {
    if (anzahl <= 0) return -1;
    if (aktuell < 0) return richtung > 0 ? 0 : anzahl - 1;
    return (aktuell + richtung + anzahl) % anzahl;
  }

  // Link der Shop-Suche
  function shopUrl(basis, anfrage) {
    var b = String(basis || '/search').split('#')[0].split('?')[0];
    var t = String(anfrage || '').replace(/^\s+|\s+$/g, '').slice(0, 100);
    return t ? b + '?q=' + encodeURIComponent(t) : b;
  }

  var api = {
    VERSION: VERSION,
    MIN_ZEICHEN: MIN_ZEICHEN,
    PRO_GRUPPE: PRO_GRUPPE,
    normalisiere: normalisiere,
    zerlegeIndex: zerlegeIndex,
    suche: suche,
    abschnitte: abschnitte,
    zielAusAdresse: zielAusAdresse,
    naechsterIndex: naechsterIndex,
    shopUrl: shopUrl
  };

  // Node (Tests): nur hier gibt es module.exports, im Browser nie
  if (typeof window === 'undefined' || typeof document === 'undefined') {
    if (typeof module === 'object' && module && module.exports) module.exports = api;
    return;
  }

  // ===========================================================================================
  // Teil 2: Seite
  // ===========================================================================================

  window.__mvSortiment = window.__mvSortiment || {};
  var MV = window.__mvSortiment;
  if (MV.ratgeber) return;

  var zaehler = 0;
  var BEWEGUNG = typeof window.matchMedia === 'function' && window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';

  function setzeText(el, text) {
    if (el) el.textContent = text;
  }

  function hinScrollen(el) {
    if (el && typeof el.scrollIntoView === 'function') el.scrollIntoView({ behavior: BEWEGUNG, block: 'start' });
  }

  function vorlage(wurzel, name) {
    var t = wurzel.querySelector('template[data-mv-ratgeber-vorlage="' + name + '"]');
    return t && t.content ? t.content.firstElementChild : null;
  }

  function iconVon(wurzel, typ) {
    var t = wurzel.querySelector('template[data-mv-ratgeber-icon="' + typ + '"]');
    return t && t.content && t.content.firstElementChild ? t.content.firstElementChild.cloneNode(true) : null;
  }

  function hinzu(ziel, teile) {
    for (var i = 0; i < teile.length; i++) {
      if (teile[i].mark) {
        var m = document.createElement('mark');
        m.className = 'mv-ratgeber-treffer__marke';
        m.textContent = teile[i].text;
        ziel.appendChild(m);
      } else {
        ziel.appendChild(document.createTextNode(teile[i].text));
      }
    }
  }

  // ---------------------------------------------------------------------------------- Suche

  function indexVon(wurzel) {
    if (wurzel.__mvRatgeberIndex) return wurzel.__mvRatgeberIndex;
    var block = wurzel.querySelector('script[data-mv-ratgeber-index]');
    var text = '';
    try { text = block ? JSON.parse(block.textContent || '""') : ''; } catch (_) { text = ''; }
    wurzel.__mvRatgeberIndex = zerlegeIndex(typeof text === 'string' ? text : '');
    return wurzel.__mvRatgeberIndex;
  }

  function optionen(box) {
    return box ? box.querySelectorAll('[role="option"]') : [];
  }

  function aktivSetzen(feld, box, i) {
    var liste = optionen(box);
    for (var k = 0; k < liste.length; k++) liste[k].removeAttribute('aria-selected');
    if (i < 0 || i >= liste.length) {
      feld.removeAttribute('aria-activedescendant');
      box.__mvAktiv = -1;
      return;
    }
    liste[i].setAttribute('aria-selected', 'true');
    feld.setAttribute('aria-activedescendant', liste[i].id);
    box.__mvAktiv = i;
    if (typeof liste[i].scrollIntoView === 'function') liste[i].scrollIntoView({ block: 'nearest' });
  }

  function schliessen(such) {
    var feld = such.querySelector('[data-mv-ratgeber-eingabe]');
    var box = such.querySelector('[data-mv-ratgeber-treffer]');
    if (!feld || !box) return;
    box.hidden = true;
    feld.setAttribute('aria-expanded', 'false');
    aktivSetzen(feld, box, -1);
  }

  function zeigeTreffer(wurzel, such) {
    var feld = such.querySelector('[data-mv-ratgeber-eingabe]');
    var box = such.querySelector('[data-mv-ratgeber-treffer]');
    var status = such.querySelector('[data-mv-ratgeber-status]');
    if (!feld || !box) return;
    var ergebnis = suche(indexVon(wurzel), feld.value);
    while (box.firstChild) box.removeChild(box.firstChild);
    if (!ergebnis) {
      schliessen(such);
      setzeText(status, '');
      return;
    }
    var basisId = box.id || 'mv-ratgeber-treffer';
    var nr = 0;
    var vGruppe = vorlage(wurzel, 'gruppe');
    var vEintrag = vorlage(wurzel, 'eintrag');
    for (var g = 0; g < ergebnis.gruppen.length && vGruppe && vEintrag; g++) {
      var gr = ergebnis.gruppen[g];
      var knoten = vGruppe.cloneNode(true);
      var kopfId = basisId + '-g' + g;
      var kopf = knoten.querySelector('[data-mv-ratgeber-typ-titel]');
      setzeText(kopf, gr.titel);
      if (kopf) kopf.id = kopfId;
      knoten.setAttribute('aria-labelledby', kopfId);
      var iconPlatz = knoten.querySelector('[data-mv-ratgeber-typ-icon]');
      var icon = iconVon(wurzel, gr.typ);
      if (iconPlatz && icon) iconPlatz.appendChild(icon);
      for (var e = 0; e < gr.eintraege.length; e++) {
        var x = gr.eintraege[e];
        var a = vEintrag.cloneNode(true);
        a.id = basisId + '-o' + (nr++);
        a.setAttribute('href', x.url);
        a.setAttribute('data-mv-ratgeber-typ', x.typ);
        var t = a.querySelector('[data-mv-ratgeber-titel]');
        if (t) hinzu(t, abschnitte(x.titel, ergebnis.anfrage));
        var k = a.querySelector('[data-mv-ratgeber-kurz]');
        var zusatz = x.kurz || x.meta;
        if (k && zusatz) hinzu(k, abschnitte(zusatz, ergebnis.anfrage));
        else if (k) k.parentNode.removeChild(k);
        knoten.appendChild(a);
      }
      box.appendChild(knoten);
    }
    if (!ergebnis.gesamt) {
      var leer = vorlage(wurzel, 'leer');
      if (leer) box.appendChild(leer.cloneNode(true));
    }
    var shop = vorlage(wurzel, 'shop');
    if (shop) {
      var s = shop.cloneNode(true);
      s.id = basisId + '-o' + (nr++);
      s.setAttribute('href', shopUrl(such.getAttribute('data-mv-shop'), feld.value));
      box.appendChild(s);
    }
    box.hidden = false;
    feld.setAttribute('aria-expanded', 'true');
    aktivSetzen(feld, box, -1);
    var n = ergebnis.gesamt;
    setzeText(status, n ? n + ' ' + (such.getAttribute('data-mv-text-treffer') || '') : (such.getAttribute('data-mv-text-keine') || ''));
  }

  function sucheStarten(wurzel, such) {
    var feld = such.querySelector('[data-mv-ratgeber-eingabe]');
    var box = such.querySelector('[data-mv-ratgeber-treffer]');
    if (!feld || !box || such.__mvBereit) return;
    such.__mvBereit = true;
    such.setAttribute('data-mv-ratgeber-aktiv', '');
    if (!box.id) box.id = 'mv-ratgeber-treffer-' + (++zaehler);
    feld.setAttribute('role', 'combobox');
    feld.setAttribute('aria-autocomplete', 'list');
    feld.setAttribute('aria-expanded', 'false');
    feld.setAttribute('aria-controls', box.id);
    box.setAttribute('role', 'listbox');
    var uhr = null;
    feld.addEventListener('input', function () {
      if (uhr) clearTimeout(uhr);
      uhr = setTimeout(function () { zeigeTreffer(wurzel, such); }, VERZOEGERUNG);
    });
    feld.addEventListener('focus', function () {
      if (feld.value && box.hidden) zeigeTreffer(wurzel, such);
    });
    feld.addEventListener('keydown', function (ev) {
      var liste = optionen(box);
      if (ev.key === 'ArrowDown' || ev.key === 'ArrowUp') {
        if (box.hidden) zeigeTreffer(wurzel, such);
        liste = optionen(box);
        if (!liste.length) return;
        ev.preventDefault();
        aktivSetzen(feld, box, naechsterIndex(typeof box.__mvAktiv === 'number' ? box.__mvAktiv : -1, liste.length, ev.key === 'ArrowDown' ? 1 : -1));
      } else if (ev.key === 'Enter') {
        var i = typeof box.__mvAktiv === 'number' ? box.__mvAktiv : -1;
        if (!box.hidden && i >= 0 && liste[i]) {
          ev.preventDefault();
          window.location.assign(liste[i].getAttribute('href'));
        }
      } else if (ev.key === 'Escape') {
        if (!box.hidden) {
          ev.preventDefault();
          schliessen(such);
        } else if (feld.value) {
          ev.preventDefault();
          feld.value = '';
          zeigeTreffer(wurzel, such);
        }
      }
    });
    such.addEventListener('focusout', function (ev) {
      if (ev.relatedTarget && such.contains(ev.relatedTarget)) return;
      setTimeout(function () {
        if (!such.contains(document.activeElement)) schliessen(such);
      }, 150);
    });
  }

  // ---------------------------------------------------------------------------------- Situationen

  function reiterVon(box) {
    return box.querySelectorAll('[data-mv-ratgeber-tab]');
  }

  function waehleSituation(box, kennung, fokus) {
    var reiter = reiterVon(box);
    var gefunden = false;
    for (var i = 0; i < reiter.length; i++) if (reiter[i].getAttribute('data-mv-ratgeber-tab') === kennung) gefunden = true;
    if (!gefunden) return false;
    for (var k = 0; k < reiter.length; k++) {
      var r = reiter[k];
      var an = r.getAttribute('data-mv-ratgeber-tab') === kennung;
      r.setAttribute('aria-selected', an ? 'true' : 'false');
      r.setAttribute('tabindex', an ? '0' : '-1');
      var set = box.querySelector('[data-mv-ratgeber-set="' + r.getAttribute('data-mv-ratgeber-tab') + '"]');
      if (set) set.hidden = !an;
      if (an && fokus) r.focus();
    }
    return true;
  }

  function situationenStarten(box) {
    if (box.__mvBereit) return;
    var reiter = reiterVon(box);
    if (!reiter.length) return;
    box.__mvBereit = true;
    box.setAttribute('data-mv-ratgeber-tabs', '');
    var wahl = box.querySelector('[data-mv-ratgeber-wahl]');
    if (wahl) {
      wahl.setAttribute('role', 'tablist');
      var punkte = wahl.children;
      for (var p = 0; p < punkte.length; p++) punkte[p].setAttribute('role', 'presentation');
    }
    for (var i = 0; i < reiter.length; i++) {
      var r = reiter[i];
      var set = box.querySelector('[data-mv-ratgeber-set="' + r.getAttribute('data-mv-ratgeber-tab') + '"]');
      r.setAttribute('role', 'tab');
      if (set) {
        r.setAttribute('aria-controls', set.id);
        set.setAttribute('role', 'tabpanel');
        set.setAttribute('aria-labelledby', r.id);
        set.removeAttribute('aria-describedby');
      }
    }
    waehleSituation(box, reiter[0].getAttribute('data-mv-ratgeber-tab'), false);
    box.addEventListener('click', function (ev) {
      var r = ev.target && ev.target.closest ? ev.target.closest('[data-mv-ratgeber-tab]') : null;
      if (!r || !box.contains(r)) return;
      ev.preventDefault();
      waehleSituation(box, r.getAttribute('data-mv-ratgeber-tab'), false);
    });
    box.addEventListener('keydown', function (ev) {
      var r = ev.target && ev.target.closest ? ev.target.closest('[data-mv-ratgeber-tab]') : null;
      if (!r) return;
      var liste = reiterVon(box);
      var i = Array.prototype.indexOf.call(liste, r);
      var neu = -1;
      if (ev.key === 'ArrowRight' || ev.key === 'ArrowDown') neu = naechsterIndex(i, liste.length, 1);
      else if (ev.key === 'ArrowLeft' || ev.key === 'ArrowUp') neu = naechsterIndex(i, liste.length, -1);
      else if (ev.key === 'Home') neu = 0;
      else if (ev.key === 'End') neu = liste.length - 1;
      if (neu < 0) return;
      ev.preventDefault();
      waehleSituation(box, liste[neu].getAttribute('data-mv-ratgeber-tab'), true);
    });
  }

  // ---------------------------------------------------------------------------------- Ziel aus der Adresse

  function zuZiel(wurzel, ziel, scrollen) {
    if (!ziel) return;
    if (ziel.art === 'situation') {
      var box = wurzel.querySelector('[data-mv-ratgeber-situationen]');
      if (box && waehleSituation(box, ziel.kennung, false) && scrollen) {
        hinScrollen(box.closest('[data-mv-ratgeber-einstieg]') || box);
      }
      return;
    }
    var kachel = wurzel.querySelector('[data-mv-ratgeber-thema="' + ziel.kennung + '"]');
    if (!kachel) return;
    var alt = wurzel.querySelectorAll('[data-mv-ratgeber-gewaehlt]');
    for (var i = 0; i < alt.length; i++) alt[i].removeAttribute('data-mv-ratgeber-gewaehlt');
    kachel.setAttribute('data-mv-ratgeber-gewaehlt', '');
    if (scrollen) hinScrollen(kachel);
  }

  function starten(bereich) {
    var wurzeln = (bereich || document).querySelectorAll('[data-mv-ratgeber]');
    if (!wurzeln.length && bereich && bereich.matches && bereich.matches('[data-mv-ratgeber]')) wurzeln = [bereich];
    for (var i = 0; i < wurzeln.length; i++) {
      var w = wurzeln[i];
      var such = w.querySelectorAll('[data-mv-ratgeber-suche]');
      for (var s = 0; s < such.length; s++) sucheStarten(w, such[s]);
      var sit = w.querySelectorAll('[data-mv-ratgeber-situationen]');
      for (var t = 0; t < sit.length; t++) situationenStarten(sit[t]);
      zuZiel(w, zielAusAdresse(window.location.search, window.location.hash), true);
    }
  }

  window.addEventListener('hashchange', function () {
    var ziel = zielAusAdresse('', window.location.hash);
    if (!ziel) return;
    var wurzeln = document.querySelectorAll('[data-mv-ratgeber]');
    for (var i = 0; i < wurzeln.length; i++) zuZiel(wurzeln[i], ziel, true);
  });

  document.addEventListener('shopify:section:load', function (e) {
    starten(e.target);
  });

  api.starten = starten;
  MV.ratgeber = api;

  function bereit() {
    starten(document);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', bereit);
  else bereit();
})();
